export default __webpack_public_path__ + "static/media/big-event-2.56c90d21.png";